<script setup>
import { computed } from 'vue'

const props = defineProps({
  canGoBack: {
    type: Boolean,
    default: false
  },
  isLastStep: {
    type: Boolean,
    default: false
  },
  nextLabel: {
    type: String,
    required: true
  },
  previousLabel: {
    type: String,
    required: true
  },
  submitLabel: {
    type: String,
    required: true
  },
  stepError: {
    type: Boolean,
    default: false
  },
  stepErrorMessage: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['back', 'next', 'submit'])

const showError = computed(() => props.stepError && props.stepErrorMessage)
</script>

<template>
  <div class="step-actions">
    <p
      v-if="showError"
      class="step-error"
    >
      {{ stepErrorMessage }}
    </p>
    <button
      v-if="canGoBack"
      class="step-button ghost"
      type="button"
      @click="emit('back')"
    >
      {{ previousLabel }}
    </button>
    <button
      v-if="!isLastStep"
      class="step-button primary button-next"
      type="button"
      @click="emit('next')"
    >
      {{ nextLabel }}
    </button>
    <button
      v-else
      class="step-button primary"
      type="button"
      @click="emit('submit')"
    >
      {{ submitLabel }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.step-actions {
  @apply flex flex-col-reverse gap-4 mt-6 lg:flex-row lg:justify-end;
}

.step-error {
  @apply text-danger ~text-lg/xl lg:mr-auto mt-3;
}

.step-button {
  @apply rounded-full px-8 py-3 text-sm transition-colors duration-200;

  &.primary {
    @apply bg-primary text-white;

    &:hover {
      @apply bg-opacity-90;
    }
  }

  &.ghost {
    @apply border border-border text-headline;

    &:hover {
      @apply bg-border bg-opacity-10;
    }
  }
}
</style>
